import { render, staticRenderFns } from "./eComm.vue?vue&type=template&id=add38dd2&scoped=true"
import script from "./eComm.vue?vue&type=script&lang=js"
export * from "./eComm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "add38dd2",
  null
  
)

export default component.exports